import React from 'react';
import classNames from 'classnames';

import { useResponsiveBreakpoints } from '../../../../hooks/useResponsiveBreakpoints';
import { useDraggableReorderableItem } from '../../../../hooks/useDraggableReorderableItem';

import { applyOpacityToHex } from '../../../../helpers/applyOpacityToHex';

import EditLineIcon from '../../../../design-system/Icons/EditLineIcon';
import RichTextArea from '../../../../design-system/RichTextArea/RichTextArea';
import DraggableLineIcon from '../../../../design-system/Icons/DraggableLineIcon';
import { ButtonIcon } from '../../../../design-system';
import { DeleteBin4LineIcon } from '../../../../design-system/Icons';

const StepCard = ({ step, icon_color, isEditable, setSteps, handleDrop, setActionModal }) => {
    const { name, description, order, temporaryId } = step;

    const { isDesktop } = useResponsiveBreakpoints();

    const isDragAndDropEnabled = isDesktop && isEditable;

    const { itemRef, dragIconRef, isDragging, handlerId } = useDraggableReorderableItem({
        itemType: 'STEP',
        item: step,
        setData: setSteps,
        handleDrop,
    });

    const iconContainerClassName = classNames(
        'absolute top-0 -left-7 cursor-grab w-[28px] h-[28px] opacity-0 group-hover:opacity-100 transition-opacity',
        {
            block: isDragAndDropEnabled,
            hidden: !isDragAndDropEnabled,
        }
    );

    const cardContainerClassName = classNames(
        'group relative p-4 rounded-2 border border-neutral-200 bg-white',
        {
            'opacity-0': isDragging,
            'opacity-100': !isDragging,
        }
    );

    return (
        <>
            <div id={temporaryId} ref={itemRef} className={cardContainerClassName}>
                <div
                    ref={dragIconRef}
                    data-handler-id={handlerId}
                    draggable={isDragAndDropEnabled}
                    className={iconContainerClassName}
                >
                    <ButtonIcon type="link" size="xs" icon={DraggableLineIcon} onClick={() => {}} />
                </div>
                <div className="flex justify-between gap-2 mb-4">
                    <div className="flex items-center gap-2">
                        <div
                            className="rounded-full h-[20px] w-fit min-w-[20px] flex items-center justify-center font-body text-body-regular-xs"
                            style={{
                                color: icon_color,
                                backgroundColor: applyOpacityToHex(icon_color, 20),
                            }}
                        >
                            {order}
                        </div>

                        <p className="font-body text-body-regular-m text-neutral-500">{name}</p>
                    </div>

                    {isEditable && (
                        <div className="flex items-center gap-2 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                            <ButtonIcon
                                type="neutral"
                                size="xs"
                                icon={EditLineIcon}
                                onClick={() => setActionModal({ action: 'edit', step })}
                            />
                            <ButtonIcon
                                type="neutral"
                                size="xs"
                                icon={DeleteBin4LineIcon}
                                onClick={() => setActionModal({ action: 'delete', step })}
                            />
                        </div>
                    )}
                </div>

                <div>
                    <RichTextArea
                        value={description}
                        previewOnly
                        autoExpand
                        isBorderHidden
                        previewMinHeight={32}
                    />
                </div>
            </div>
        </>
    );
};

export default StepCard;
